<template>
    <div class="layout">

        <HeaderComponent />

        <main class="main-content">

            <router-view />
        </main>

        <FooterComponent />

    </div>
</template>

<script setup>
import HeaderComponent from '../header/HeaderComponent.vue'
import FooterComponent from '../footer/FooterComponent.vue'
</script>

<style scoped>
.layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
}
</style>